import { Navigate } from "react-router-dom";
import { getToken } from "../utils/storage";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = getToken()

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
